import React from 'react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container, Icon } from 'semantic-ui-react';
import SchemaModalForm from '../../drive/FormBuilder/SchemaModalForm'
class Demo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        return (
            <Container fluid className="pad_20">
                <SchemaModalForm />
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {

    };
}

const a = withRouter(connect(mapStateToProps)(Demo));

export { a as Demo };
